import { webAssetsCdnBaseUrl } from "@/shared/constants";

export const tool = "ai-meme-generator" as const;
export const frameCostPerMeme = 10;
export const maxCharacter = 200;

export const memeTemplates = [
  "Random",
  "Drake Hotline Bling",
  "Galaxy Brain",
  "Two Buttons",
  "Gru's Plan",
  "Tuxedo Winnie The Pooh",
  "Is This a Pigeon",
  "Panik Kalm Panik",
  "Disappointed Guy",
  "Waiting Skeleton",
  "Bike Fall",
  "Change My Mind",
  "Side Eyeing Chloe",
] as const;

export const memeTemplateImages = {
  Random: `${webAssetsCdnBaseUrl}/products/${tool}/templates/random-meme.jpg`,
  "Drake Hotline Bling": `${webAssetsCdnBaseUrl}/products/${tool}/templates/drake-hotline-bling.jpg`,
  "Galaxy Brain": `${webAssetsCdnBaseUrl}/products/${tool}/templates/galaxy-brain.jpg`,
  "Two Buttons": `${webAssetsCdnBaseUrl}/products/${tool}/templates/two-buttons.jpg`,
  "Gru's Plan": `${webAssetsCdnBaseUrl}/products/${tool}/templates/grus-plan.jpg`,
  "Tuxedo Winnie The Pooh": `${webAssetsCdnBaseUrl}/products/${tool}/templates/tuxedo-winnie-the-pooh.jpg`,
  "Is This a Pigeon": `${webAssetsCdnBaseUrl}/products/${tool}/templates/is-this-a-pigeon.jpg`,
  "Panik Kalm Panik": `${webAssetsCdnBaseUrl}/products/${tool}/templates/panik-kalm-panik.jpg`,
  "Disappointed Guy": `${webAssetsCdnBaseUrl}/products/${tool}/templates/disappointed-guy.jpg`,
  "Waiting Skeleton": `${webAssetsCdnBaseUrl}/products/${tool}/templates/waiting-skeleton.jpg`,
  "Bike Fall": `${webAssetsCdnBaseUrl}/products/${tool}/templates/bike-fall.jpg`,
  "Change My Mind": `${webAssetsCdnBaseUrl}/products/${tool}/templates/change-my-mind.jpg`,
  "Side Eyeing Chloe": `${webAssetsCdnBaseUrl}/products/${tool}/templates/side-eyeing-chloe.jpg`,
} satisfies { [key in (typeof memeTemplates)[number]]: string };

export function randomizeMemeTemplate(
  template: (typeof memeTemplates)[number]
): Exclude<(typeof memeTemplates)[number], "Random"> {
  if (template !== "Random") return template;

  // Get all templates except "Random"
  const availableTemplates = memeTemplates.slice(1) as Exclude<
    (typeof memeTemplates)[number],
    "Random"
  >[];
  const randomIndex = Math.floor(Math.random() * availableTemplates.length);
  const selectedTemplate = availableTemplates[randomIndex];

  // TypeScript doesn't know that availableTemplates will always have elements
  // since we sliced from index 1, but we know it will
  return selectedTemplate as Exclude<(typeof memeTemplates)[number], "Random">;
}
